'use strict';

exports.__esModule = true;
exports.loaders = undefined;

var _doctifyGlobalRedux = require('doctify-global-redux');

var _doctifyGlobalRedux2 = _interopRequireDefault(_doctifyGlobalRedux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSpecialties = _doctifyGlobalRedux2.default.globalActions.ListingsActions.getSpecialties;
var loaders = exports.loaders = [{
	key: 'listings.specialties',
	action: getSpecialties
}];


// WEBPACK FOOTER //
// ./components/global-components/lib/utils/loaders.js